<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="400"
    offset-x
  >
    <v-badge
      slot="activator"
      color="transparent"
      overlap
    >
      <span
        slot="badge"
        class="font-weight-bold subheading"
      >{{ shippings.length }}</span>
      <v-icon
        large
        color="grey darken-4"
      >
        local_shipping
      </v-icon>
    </v-badge>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="shippings"
        hide-actions
        flat
        :class="[shippings.length > 10 ? 'menuHeight' : '', 'elevation-1']"
        :loading="loading"
      >
        <template
          slot="items"
          slot-scope="props"
        >
          <td>
            <router-link
              target="_blank"
              :to="{name: 'shipping', params: {id: props.item.id.toString()}}"
            >
              {{ props.item.number }}
            </router-link>
          </td>
          <td>{{ props.item.date }}</td>
          <td>{{ props.item.client }}</td>
          <td>{{ props.item.factory }}</td>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-spacer />
        <v-btn
          small
          flat
          @click="menu = false"
        >
          Закрыть
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { getSameRegionShipping } from "../../../../backend/shippingsApi.js";

export default {
  props: ["id"],
  data() {
    return {
      menu: false,
      shippings: [],
      headers: [
        { text: "Номер", sortable: false },
        { text: "Дата", sortable: false },
        { text: "Клиент", sortable: false },
        { text: "Производитель", sortable: false },
      ],
      loading: false,
    };
  },
  watch: {
    menu(value) {
      if (value) {
        this.getData();
      }
    },
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      this.shippings = [];
      if (this.id) {
        this.loading = true;
        const res = await getSameRegionShipping(this.id);
        this.shippings = res.data.map(s => {
          return {
            id: s.Id,
            number: s.Number,
            date: this.$options.filters.date(s.Date),
            client: s.Client.Title,
            factory: s.Factory ? s.Factory.Title : "Нет данных",
          };
        });
        this.loading = false;
      }
      this.$store.commit(
        "shipping/setSameRegionShipping",
        this.shippings.length,
      );
    },
  },
};
</script>

<style>
.v-badge--overlap .v-badge__badge {
  top: 5px !important;
  right: 10px !important;
}
.menuHeight {
  height: 385px;
  overflow-y: scroll;
}
</style>
